import './layout.scss';
import '../menu/menu.scss';
import '../input/dropdownInput-v1-1.scss';

import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';

import { useStore } from '../../store/storeHooks';
import { type UserRole } from '../../entities/userSchema';
import { UserAvatar } from './userAvatar';
import { UserAccountDropdown } from './userAccountDropdown';

const getRole = (roles: UserRole[] | string[] | undefined) => {
  if (roles?.includes('Super Admin')) {
    return 'Super Admin';
  } else if (roles?.includes('Admin')) {
    return 'Admin';
  } else if (roles?.includes('Agency sponsor')) {
    return 'Agency admin';
  } else if (roles?.includes('Trainer')) {
    return 'Trainer';
  } else if (roles?.includes('Operator')) {
    return 'Operator';
  } else {
    return 'Member';
  }
};

type Props = {
  showProfile: boolean;
  showHelp: boolean;
  showLogout: boolean;
  onLogoutButtonClick?: React.MouseEventHandler;
  onHelpButtonClick?: React.MouseEventHandler;
}

export const UserCard = observer(({ 
  showHelp, 
  showProfile, 
  showLogout, 
  onLogoutButtonClick,
  onHelpButtonClick
}: Props) => {

  const store = useStore();
  const { localUser } = store.profilePage;
  const [isOpened, setIsOpened] = useState(false);
  const userRole = getRole(store?.user?.roles);
  const showDropdown = showLogout || showHelp || showProfile;
  const displayName = localUser?.name || store.user?.name || store.user?.username;

  return (
    <div className="user-card">
      <UserAvatar
        className="light-blue"
        onClick={() => setIsOpened(!isOpened)}
        model={localUser ?? store.authService.userProfile} />

      <div className="user-info" onClick={() => setIsOpened(!isOpened)}>
        <p className="user-name" title={displayName ?? undefined}>{displayName}</p>
        <p className="user-role">{userRole}</p>
      </div>

      {showDropdown &&
        <UserAccountDropdown
          showLogout={showLogout}
          showHelp={showHelp}
          showProfile={showProfile}
          isOpened={isOpened}
          setIsOpened={setIsOpened}
          onLogoutButtonClick={onLogoutButtonClick}
          onHelpButtonClick={onHelpButtonClick} />}
    </div>
  );
});
